import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { t } from "../../i18n";
import { CONSENT_TXT } from "../../lib/checkoutHelpers";
import { RecurrenceCard } from "./RecurrenceCard";

const ConsentRow = ({ locale, consent, setConsent }) => {
  const txt = CONSENT_TXT[locale] || CONSENT_TXT.en;
  return (
    <label className="flex items-start gap-3 text-xs text-charcoal cursor-pointer" data-testid="consent-row">
      <input type="checkbox" data-testid="consent-checkbox" className="mt-0.5 shrink-0"
             checked={consent} onChange={(e) => setConsent(e.target.checked)} />
      <span>
        {txt[0]}{" "}
        <Link to={`/${locale}/terms`} target="_blank" className="text-brass underline">{t(locale, "terms")}</Link>,{" "}
        <Link to={`/${locale}/privacy`} target="_blank" className="text-brass underline">{t(locale, "privacy")}</Link>{" "}
        {txt[1]}{" "}
        <Link to={`/${locale}/refunds`} target="_blank" className="text-brass underline">{t(locale, "refundPolicy")}</Link>.
      </span>
    </label>
  );
};

export const PaymentStep = ({ locale, recurrence, gateway, error, consent, setConsent, canPay, busy, quote, payTotal,
                              recurring, onPay, onBack, held }) => (
  <section className="space-y-6" data-testid="checkout-payment">
    <h1 className="font-display text-3xl text-ink">{t(locale, "payTitle")}</h1>
    <RecurrenceCard locale={locale} {...recurrence} />
    <div className="border border-brass-light bg-plaster p-5 space-y-2" data-testid="gateway-box">
      <p className="text-sm text-ink flex items-center gap-2"><Lock size={14} className="text-brass" />{t(locale, "payWith").replace("{gateway}", gateway)}</p>
      <p className="text-xs text-muted">{t(locale, "preauthNote")}</p>
    </div>
    {error ? <p role="alert" className="text-danger text-sm" data-testid="checkout-error">{error}</p> : null}
    <ConsentRow locale={locale} consent={consent} setConsent={setConsent} />
    <button data-testid="pay-button" className="btn-primary w-full text-base py-4" disabled={!canPay} onClick={onPay}>
      {busy || !quote ? "…" : `${recurring ? t(locale, "startPlan") : t(locale, "payNow")} · ${quote.symbol} ${payTotal}`}
    </button>
    <div className="flex flex-wrap gap-4 justify-between items-center">
      <button className="btn-ghost" data-testid="checkout-back-3" onClick={onBack}>{t(locale, "back")}</button>
      {held ? <p className="text-xs text-muted" data-testid="basket-held">{t(locale, "basketSaved")}</p> : null}
    </div>
    <p className="text-xs text-muted flex items-center gap-2" data-testid="payment-note">
      <Lock size={13} className="text-brass" />
      {t(locale, "paymentNote").replace("Stripe", gateway)}
    </p>
  </section>
);
